import AppConstants from '../../Constants/AppConstants';

const key = () => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:payments:wallet-config`;
export const readWalletConfigDraft = () => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(key()) || '{}');
    return draft && typeof draft.switchValue === 'boolean' ? draft : {};
  } catch (error) { return {}; }
};
export const writeWalletConfigDraft = switchValue => {
  try { window.localStorage.setItem(key(), JSON.stringify({switchValue: Boolean(switchValue)})); }
  catch (error) { /* Keep settings usable if browser storage is unavailable. */ }
};
export const clearWalletConfigDraft = () => {
  try { window.localStorage.removeItem(key()); }
  catch (error) { /* Ignore storage errors after a successful save. */ }
};
